/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

;(function ($) {

    $(document).ready(function(){
		//console.log('custom.js is loading');

		//collections
		// jQuery.getJSON('/collections.json', function(data) {
		//   //console.log(data);
		// });

		// //collection
		// jQuery.getJSON('/collections/yoga?view=json', function(data) {
		//   //console.log(data);
		// });

		// //products
		// jQuery.getJSON('/products.json', function(data) {
		//   //console.log(data);
		// });
		// jQuery.getJSON('/collections/boards/products.json', function(data) {
		//   //console.log(data);
		// });

		// //pages
		// jQuery.getJSON('/admin/pages.json', function(data) {
		//   //console.log(data);
		// });

		// //single page
		// jQuery.getJSON('/admin/pages/26836533302.json', function(data) {
		//   //console.log(data);
		// });

		// //product metafields
		// jQuery.getJSON('/admin/products/1998354153526/metafields.json', function(data) {
		//   //console.log(data);
		// });

		//get blogs
		//https://hala-gear.myshopify.com/admin/api/2019-04/blogs.json
		
		//get blog articles (use blog id)
		//https://hala-gear.myshopify.com/admin/api/2019-04/blogs/29849223222/articles.json
		
		openExternalLinks();
		productShareLinks();
		productBackorder();
		productInfo();
		contactMap();
		faq();
		topPicks();
		footerMenus();
		revealPlusButton();
		//chooseRegion();
		toggleHamburgerMenu();
		closeVideo();
		//homeVideoCookie();
		homeHeroTabs();
		googlePlacesAddress();
		newsletterPopup();
		bindVideoPlayer();
    });

    //functions
    function openExternalLinks() {
    	var links = document.links;
    	for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    	  if (links[i].hostname !== window.location.hostname) {
    	      links[i].target = '_blank';
    	  }
    	}
    }

    function productShareLinks() {
    	$('.open-product-share').click(function(e){
    		e.preventDefault();
    		$('.Product__ShareList').attr('aria-hidden', function (i, attr) {
    		    return attr == 'true' ? 'false' : 'true'
    		});
    	});
    }

    function productBackorder() {
    	if ( document.getElementById('shopify-section-product-backorder-template') ) {
    		jQuery.getJSON("https://spreadsheets.google.com/feeds/list/14odK722dWXMO2zgjj5SPfwP-mbVc7BeVYlTvmRhGAK8/1/public/values?alt=json", function(data) {
    		  	//console.log(data.feed.entry);
    		  	var entry = data.feed.entry;
    		  	var product_id = $('.Product__Tabs').data('shopify-id');

    		  	$(entry).each(function(){
    		  		//match to shopify product
    		  		if (this.gsx$shopifyid.$t == product_id) {
    		  			var bkorder = this.gsx$backordermessage.$t;
    		  			$('.backorder-message-text').html(bkorder);
    		  		}
    		  	});	 		
    		});
    	}	
    }

    function productInfo() { 
    	if ( document.getElementById('shopify-section-product-template') || document.getElementById('shopify-section-product-backorder-template') ) {
			
			//Products Tab
	    	jQuery.getJSON("https://spreadsheets.google.com/feeds/list/14odK722dWXMO2zgjj5SPfwP-mbVc7BeVYlTvmRhGAK8/1/public/values?alt=json", function(data) {
	    	  	console.log(data.feed.entry);
	    	  	var entry = data.feed.entry;
	    	  	var product_id = $('.Product__Tabs').data('shopify-id');
	    	  	$('.Specs-Drawer').hide();
			    $(entry).each(function(){
			    	if (this.gsx$shopifyid.$t == product_id) {
			    		$('.Specs-Drawer').show();
			    		var specs = '<table class="product-specs-table">'
										+'<tr>'
											+'<td class="spec-name">Length</td><td>'+this.gsx$length.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Width</td><td>'+this.gsx$width.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Thickness</td><td>'+this.gsx$thickness.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Weight</td><td>'+this.gsx$weightlbs.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Volume</td><td>'+this.gsx$volume.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Rider Capacity</td><td>'+this.gsx$ridercapacity.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Best for</td><td>'+this.gsx$bestfor.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Drop Stitch</td><td>'+this.gsx$dropstitch.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Stiffening Tech</td><td>'+this.gsx$stiffeningtech.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Center fin</td><td>'+this.gsx$centerfin.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Side Bite Fins</td><td>'+this.gsx$sidebitefins.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Rigging</td><td>'+this.gsx$rigging.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Deck Pad</td><td>'+this.gsx$deckpad.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Stomp Pad + Foot Index</td><td>'+this.gsx$stomppadfootindex.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Backpack</td><td>'+this.gsx$backpack.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Speed</td><td>'+this.gsx$speed.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Stability</td><td>'+this.gsx$stability.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Manuverability</td><td>'+this.gsx$manuverability.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Tracking</td><td>'+this.gsx$tracking.$t+'</td>'
										+'</tr>'
										+'<tr>'
											+'<td class="spec-name">Warranty</td><td>'+this.gsx$warranty.$t+'</td>'
										+'</tr>'
									+'</table>';
			    		$('#one-product-specs').html(specs);

			    		//if all the spec fields are empty, hide the specs drawer
			    		if (this.gsx$length.$t == '' && this.gsx$width.$t == '' && this.gsx$thickness.$t == '' && this.gsx$weightlbs.$t == '' && this.gsx$volume.$t == '' && this.gsx$ridercapacity.$t == '' && this.gsx$bestfor.$t == '' && this.gsx$dropstitch.$t == '' && this.gsx$stiffeningtech.$t == '' && this.gsx$centerfin.$t == '' && this.gsx$sidebitefins.$t == '' && this.gsx$rigging.$t == '' && this.gsx$deckpad.$t == '' && this.gsx$stomppadfootindex.$t == '' && this.gsx$backpack.$t == '' && this.gsx$speed.$t == '' && this.gsx$stability.$t == '' && this.gsx$manuverability.$t == '' && this.gsx$tracking.$t == '' && this.gsx$warranty.$t == '') {
			    			console.log('all spec fields are empty');
			    			$('.Specs-Drawer').hide();
			    		}

			    		var full_image = '<img src="'+this.gsx$fullwidthimage.$t+'" alt="'+this.gsx$fullwithimagealt.$t+'">';
			    		$('.Full-Width-Product-Image').append(full_image);
			    	} 
			    });
	    	});


			//Tech Block choices Tab
	    	jQuery.getJSON("https://spreadsheets.google.com/feeds/list/14odK722dWXMO2zgjj5SPfwP-mbVc7BeVYlTvmRhGAK8/2/public/values?alt=json", function(data) {
	    	  	//console.log(data.feed.entry);
	    	  	var entry = data.feed.entry;
	    	  	var product_id = $('.Product__Tabs').data('shopify-id');

	    	  	$(entry).each(function(){
	    	  		//match to shopify product
	    	  		if (this.gsx$shopifyid.$t == product_id) {
	    	  			var tblocks = this.gsx$techblocks.$t;
	    	  			var tarray = tblocks.split(',');
	    	  			tarray = jQuery.grep(tarray, function(n){ return (n); });
	    	  			for (var i = 0; i < tarray.length; i++) { 
	    	  				matchTechBlock(tarray[i]);
	    	  			}
	    	  		} 
	    	  	});	 		
	    	});

	    	function matchTechBlock(block) {
	    		//Tech Blocks tab
	    		jQuery.getJSON("https://spreadsheets.google.com/feeds/list/14odK722dWXMO2zgjj5SPfwP-mbVc7BeVYlTvmRhGAK8/3/public/values?alt=json", function(blocks) {
	    		  	var techblocks = blocks.feed.entry;
	    			$(techblocks).each(function(){
	    				//match to tech block
	    				if (this.gsx$title.$t == block) {
	    					var one_block = '<div class="one-tech-block">'
												+'<img src="'+this.gsx$image.$t+'" alt="">'
												+'<h6 class="text-black">'+this.gsx$title.$t+'</h6>'
												+'<p class="text-gray">'+this.gsx$description.$t+'</p>'
											+'</div>';
							$('#one-product-tech-blocks').append(one_block);
	    				} 
	    			});	
	    		}); 
	    	}
	    }	
    }

    function contactMap() {
    	if ( document.getElementById('contact-map') ) { 
    	    //console.log('contact map here');
    	    var address = $('#contact-map').data('address');
    	    var tr_address = address.trim();		
    	    var encoded_a = encodeURIComponent(tr_address);
    	    var mapbox_token = 'pk.eyJ1IjoiYmxrZGciLCJhIjoiY2s3MjV0cWNxMDNjcTNscGZkbXd4MWdhdCJ9.cNUUBRDow3j71FWy8S3KyA';
    	    jQuery.getJSON('https://api.mapbox.com/geocoding/v5/mapbox.places/'+encoded_a+'.json?access_token='+mapbox_token, function(data) {
			  var lat = data.features[0].geometry.coordinates[0];
			  var lng = data.features[0].geometry.coordinates[1];
			  buildMap(lat,lng,address,encoded_a);
			});

    	    function buildMap(lat,lng,address,encoded) {
    	    	mapboxgl.accessToken = 'pk.eyJ1IjoiYmxrZGciLCJhIjoiY2s3MjV0cWNxMDNjcTNscGZkbXd4MWdhdCJ9.cNUUBRDow3j71FWy8S3KyA';
    	    	var map = new mapboxgl.Map({
    	    	    container: 'contact-map',
    	    	    style: 'mapbox://styles/blkdg/cjtrmhgdj73z91fmt93t9x66z',
    	    	    center: [lat,lng],
    	    	    zoom: 13
    	    	});

    	    	//disable standard scroll to zoom
    	    	map.scrollZoom.disable();
    	    	//add zoom controls
    	    	map.addControl(new mapboxgl.NavigationControl());

    	    	map.on("load", function () {
					map.addLayer({
						id: "markers",
						type: "symbol",
						source: {
							type: "geojson",
							data: {
								type: 'FeatureCollection',
								features: [
									{
										type: 'Feature',
										properties: {},
										geometry: {
											type: "Point",
											coordinates: [lat,lng]
										}
									}
								]
							}
						},
						layout: {
						"icon-image": "icon-map-pin",
						}
					});
				});	

				map.on('click', function(e) {
				    var features = map.queryRenderedFeatures(e.point, {
				        layers: ['markers']
				    });

				    if (features.length) {
				          var clickedPoint = features[0];
				          flyToStore(clickedPoint);
				          createPopUp(clickedPoint,address,encoded);
				    }
				});

				function flyToStore(currentFeature) {
				    map.flyTo({
				        center: currentFeature.geometry.coordinates,
				        zoom: 15
				    });
				}  

				function createPopUp(currentFeature,address,encoded) {
				    var popUps = document.getElementsByClassName('mapboxgl-popup');
				    if (popUps[0]) popUps[0].remove();


				    var popup = new mapboxgl.Popup({closeOnClick: false})
				    .setLngLat(currentFeature.geometry.coordinates)
				    .setHTML('<p><a target="_blank" href="https://www.google.com/maps/place/' + encoded + '">' + address + '</a></p>')
				    .addTo(map);
				}
    	    }    	    
    	}
    }

    function faq() {
    	$('.faq-cat').click(function(e){
    		e.preventDefault();
    		$('.faq-cat').removeClass('selected');
    		$(this).addClass('selected');
    		var cat = $(this).data('cat');
    		$('.one-qa-title').each(function(){
    			var p_cat = $(this).data('cat');
    			if (cat == p_cat) {
    				$(this).show();
    			} else {
    				$(this).hide();
    			}
    		});
    		$('.one-qa').each(function(){
    			var p_cat = $(this).data('cat');
    			if (cat == p_cat) {
    				$(this).show();
    			} else {
    				$(this).hide();
    			}
    		});
    	});
    	$('.one-faq-q').click(function(e){
    		e.preventDefault();
    		$(this).toggleClass('reveal');
    		$(this).siblings().fadeToggle();
    	});
    }

    function topPicks() {
    	$('.one-top-pick-cat').first().addClass('selected');
    	$('.slider-main-button').first().css('display', 'block');
    	$('.one-top-pick-cat').click(function(e){
    		e.preventDefault();
    		$(this).addClass('selected');
    		$(this).siblings().removeClass('selected');
    		var handle = $(this).data('cat');
    		filterTopPicks(handle);
    	});
    	$('#filter-top-picks').on('change', function(e){
    		e.preventDefault();
    		var handle = $(this).val();
    		filterTopPicks(handle);
    	});
    }
    function filterTopPicks(handle) {
    	var picks = $('.pick-slider-container');
    	picks.each(function(){
    		if ($(this).hasClass(handle)) {
    			$(this).css('display', 'block');
    			$(this).find('.one-pick-slider').flickity("resize");
    		} else {
    			$(this).css('display', 'none');
    		}
    	});
    	var buttons = $('.slider-main-button');
    	buttons.each(function(){
    		if ($(this).hasClass(handle)) {
    			$(this).css('display', 'block');
    		} else {
    			$(this).css('display', 'none');
    		}
    	});
    }

    function footerMenus() {
    	if ( $(window).width() < 1008 ) {
	    	$('.footer-menu-1').click(function(e){
	    		e.preventDefault();
	    		$(this).toggleClass('open');
	    		$('.footer-menu-list-1').toggleClass('reveal');
	    	});
	    	$('.footer-menu-2').click(function(e){
	    		e.preventDefault();
	    		$(this).toggleClass('open');
	    		$('.footer-menu-list-2').toggleClass('reveal');
	    	});
	    	$('.footer-menu-3').click(function(e){
	    		e.preventDefault();
	    		$(this).toggleClass('open');
	    		$('.inner-customer-service').toggleClass('reveal');
	    	});
	    	$('.footer-menu-4').click(function(e){
	    		e.preventDefault();
	    		$(this).toggleClass('open');
	    		$('.inner-protips').toggleClass('reveal');
	    	});
	    }	
    }

    function newsletterPopup() {
    	$('#open-form-popup').click(function(e){
    		e.preventDefault();
    		$('#form-popup').fadeIn();
    	});
    	$('#close-form-popup').click(function(e){
    		e.preventDefault();
    		$('#form-popup').fadeOut();
    	});
    }

    function googlePlacesAddress() {
		var hq_address = $('#hq-address').text().trim();		
		var encoded_hq = encodeURIComponent(hq_address);
		var google_link = 'https://www.google.com/maps/place/'+encoded_hq;
    	$('#google-hq-address').attr('href', google_link);
    	$('#google-contact-address').attr('href', google_link);
    }

    function revealPlusButton() {
    	$('.cut-corners-bkgd').bind('mouseenter', function(e){
    	    $(this).append('<div class="inner-plus"></div>');
    	});
    	$('.cut-corners-bkgd').bind('mouseleave', function(e){
    	    $(this).find('.inner-plus').remove();
    	});
    }
  	
    function chooseRegion() {
    	$('#choose-region-header, #choose-region-mobile').click(function(e){
    		e.preventDefault();
    		$('#region-container').fadeIn();
    	});
    	$('#close-region').click(function(e){
    		e.preventDefault();
    		$('#region-container').fadeOut();
    	});
    }
    function toggleHamburgerMenu() {
    	$('#mobile-menu').click(function(e){
    		e.preventDefault();
    		//$('html').toggleClass('no-scroll');

    		$('#mobile-menu').toggleClass('open');
    		$('.SidebarMenu').toggleClass('reveal');
    		if ($('.SidebarMenu').hasClass('reveal')) {
    			$('.SidebarMenu').attr('aria-hidden', 'false');
    			$('.PageOverlay').addClass('is-visible');
    			if ( $(window).width() < 1008 ) {
    				$('#shopify-section-announcement').css('display','none');
    			} else {
    				$('#shopify-section-announcement').fadeOut();
    			}
    		} else {
    			$('.SidebarMenu').attr('aria-hidden', 'true');
    			$('.PageOverlay').removeClass('is-visible');
    			if ( $(window).width() < 1008 ) {
    				$('#shopify-section-announcement').css('display','block');
    			} else {
    				$('#shopify-section-announcement').fadeIn();
    			}
    		}	
    		if ($('.PageOverlay').hasClass('is-visible')) {
    			$('#mobile-menu').addClass('open');
    		} else {
    			$('#mobile-menu').removeClass('open');
    		}
    	});
    }

    function closeVideo() {
    	$('#close-video').click(function(e){
    		e.preventDefault();
    		$('.Home-Hero-Video').hide();
    		$('.Home-Hero-Content').fadeIn();
    		$('.one-series').find('.flickity-enabled').css('height', '642px');
    		$('.one-series').find('.flickity-viewport').css('height', '642px');
    	});
    }

    function homeVideoCookie() {
    	if(Cookies.get('HomeVid')){
    		$('.Home-Hero-Video').hide();
    		$('.Home-Hero-Content').show();
    		$('.one-series').find('.flickity-enabled').css('height', '642px');
    		$('.one-series').find('.flickity-viewport').css('height', '642px');
    	} else {
    		$('.Home-Hero-Video').show();
    		Cookies.set('HomeVid', { expires: 30, path: '' });  
    	}	
    }

    function homeHeroTabs() {
    	$('.one-tab').click(function(e){
    		e.preventDefault();
    		$('.one-tab').removeClass('selected');
    		$('.one-tab').children().addClass('show');
    		$(this).addClass('selected');
    		$(this).children().removeClass('show');
    		var type = $(this).children().data('type');
    		var series = $('.one-series');
    		series.each(function(){
    			if ($(this).hasClass(type)) {
    				$(this).css('display', 'block');
    				$(this).find('.flickity-enabled').css('height', '642px');
    				$(this).find('.flickity-viewport').css('height', '642px');
    			} else {
    				$(this).css('display', 'none');
    			}
    		});
    	});
    }

	/**
     * Video Player
     */
	 var autoPlayVideo = function autoPlayVideo(tar, vcode, isHosted, title) {
		"use strict";
	  
		$(tar).off('click');
		if (isHosted === 'true') {
			$(tar).html('<video title="'+title+'" width="100%" loop="true" src="' + vcode + '" autoplay="" preload="auto" controls playsinline=""></video>');
		} else {
			$(tar).html('<iframe title="'+title+'" width="100%" height="100%" allow="autoplay" src="https://www.youtube.com/embed/' + vcode + '?autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen wmode="Opaque"></iframe>');
		}
	  };
	  
	  var bindVideoPlayer = function bindVideoPlayer() {
		if ($('[data-video]').length > 0) {
			$('[data-video]').each(function () {
				$(this).on('click', function (event) {
					var vcode = $(this).attr('data-id');
					var isHosted = $(this).attr('data-hosted');
					var title = $(this).attr('data-title');
	  
					autoPlayVideo(this, vcode, isHosted, title);
				});
			});
		}
	  };
	
      $('select.addon_select').on('change',function(){
        var value = $('option:selected', this).val();
        var p_id = $(this).attr('id');
        var cprice = $('option:selected', this).attr('data-cprice');
        var mprice = $('option:selected', this).attr('data-price');
        $("input.addon-checkbox#"+p_id).val(value);
        $('.product-addon-info[data-product_id="'+p_id+'"] span.discount').html(mprice);
        if (cprice){
          $('.product-addon-info[data-product_id="'+p_id+'"] strike').text('('+cprice+')');
        } else {
          $('.product-addon-info[data-product_id="'+p_id+'"] strike').text('');
        }
      });
  
	  $('input.addon-checkbox:checkbox').change(function(){
          if($(this).is(":checked")) {
              $(this).parent().addClass("active_product");
          } else {
              $(this).parent().removeClass("active_product");
          }
        
//           if($(this).prop("checked") == true){
//             $(this).attr("checked", "checked");
//             $(this).parent().addClass("active_product");
//             var p_id = $(this).attr('data-p_id');
//             var v_id = $(this).val();
//             $('.ProductForm__Variants input.pro_id[data_id="'+p_id+'"]').val(v_id).attr('name','id[]');
//           }
//           else if($(this).prop("checked") == false){
//             $(this).removeAttr('checked');
//             $(this).parent().addClass("active_product");
//             var p_id = $(this).attr('data-p_id');
//             $('.ProductForm__Variants input.pro_id[data_id="'+p_id+'"]').val('').removeAttr('name');
//           }
        
      });
     
//       $('.ProductForm__AddToCart').on('click', function(){
//           $('#custom-add-item-form').submit();
//       });

  $('#collection-sort-popover button.Popover__Value,#collection-filter-drawer button.ButtonGroup__Item[data-action="apply-tags"]').click(function(){
    setTimeout(function() {
      var pageURL = $(location).attr("href");
      location.reload();
    }, 1000);
    
  });
  var affirm_logo= "<img src='https://cdn.shopify.com/s/files/1/0255/4029/6738/files/Affirm_logo.png?v=1646920046' class='affirm_logo'>";
  function affirmlogo() {
    $(".affirm-as-low-as").text(function () {
      $(this).html( $(this).html().replace("Affirm", affirm_logo));
    });
  }
  setTimeout(function() {
    if (window.location.href.indexOf("cart") > -1) {
     //affirmlogo();
    }
    if (window.location.href.indexOf("/products/") > -1) {
     //affirmlogo();
    }
  }, 3000);
  

  $('.slick-vertical').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping:true,
    arrows: true,
    focusOnSelect: true,
    infinite: false
    ,
  });


  
})(jQuery);
